<div class="inter-intervention-item">
  <a routerLink="/intervention/{{interventionId}}">
    <div class="inter-intervention-item_container pointer pasi-hover_scale">
      <div class="row pasi-gap-v-12">
        <div class="col col-sm-6 order-0 mr-auto" [ngClass]="{'col-lg ': forceMobile}">
          <div class="d-flex mb-2">
            <div *ngIf="admissionDate; else interventionDateTemplate">
              <div class="inter-intervention-item_container_title text-nowrap">
                {{admissionDate | amDateFormat: 'DD MMM' | uppercase}}
              </div>
              <div class="inter-intervention-item_container_year text-right">
                {{admissionDate | amDateFormat: 'YYYY'}}
              </div>
              <div class="inter-intervention-item_container_title text-nowrap d-flex justify-content-end">
                {{admissionDate | amDateFormat: 'HH:mm'}}{{'SI_HOUR_UNIT' | translate | lowercase}}
              </div>
            </div>
            <ng-template #interventionDateTemplate>
              <div>
                <div class="inter-intervention-item_container_title text-nowrap">
                  {{interventionDate | amDateFormat: 'DD MMM' | uppercase}}
                </div>
                <div class="inter-intervention-item_container_year text-right">
                  {{interventionDate | amDateFormat: 'YYYY'}}
                </div>
              </div>
            </ng-template>
            <div class="inter-intervention-item_container_line"></div>
            <div class="inter-intervention-item_container_info flex-grow-1">
              <div class="inter-intervention-item_container_title">{{serviceName}}</div>
              <div *ngIf="procedures?.length" class="d-flex flex-grow-1 align-items-center">
                <i class="icon-aidkit font-big"></i>
                <span class="ml-2">{{procedures[0].name}}</span>
              </div>
              <div *ngIf="admissionDate && !(admissionDate | sameDay: interventionDate)" class="d-flex flex-grow-1 align-items-center">
                <i class="icosun-calendar font-big"></i>
                <span class="ml-2">{{'SI_INTERVENTION_DATE' | translate}}:&nbsp;{{interventionDate | amDateFormat: 'DD MMMM'}}</span>
              </div>
              <div *ngIf="professionalName" class="d-flex flex-grow-1 align-items-center">
                <i class="icosun-professional"></i>
                <span class="ml-2">{{professionalName}}</span>
              </div>
              <div *ngIf="centerName" class="d-flex flex-grow-1 align-items-center">
                <i class="icosun-map"></i>
                <span class="ml-2">{{centerName}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a>
</div>
